module.exports = __webpack_public_path__ + "static/img/apple.c7d5edc4.png";